import React, { useState } from 'react'
import { Button, TextField, Container, Grid } from "@mui/material";
import adaptabilityIcon from '../assets/Navigation/nav_icon_adaptability_green.png'
import dataIcon from '../assets/Navigation/nav_icon_quality_green.png'
import costIcon from '../assets/Navigation/nav_icon_cost_green.png'
import expertiseIcon from '../assets/Navigation/nav_icon_expertise_green.png'
import Result from '../components/Result'
import {selectAdaptabilityQuestions} from '../features/adaptability/adaptabilitySlice'
import { selectDataQuestions } from '../features/data/dataSlice'
import {selectCostQuestions} from '../features/cost/costSlice'
import { selectExpertiseQuestions } from '../features/expertise/expertiseSlice'
import { useSelector } from 'react-redux'
import Oops from '../components/Oops'
import { jsPDF } from "jspdf";
import chart1 from "../assets/results/results_1st.jpg";
import chart2 from "../assets/results/results_2nd.jpg";
import chart3 from "../assets/results/results_3rd.jpg";
import chart4 from "../assets/results/results_4th.jpg";

import { ArrowForwardIos } from '@mui/icons-material'

const Results = () => {
    const adaptabilityQuestions = useSelector(selectAdaptabilityQuestions)
    const dataQuestions = useSelector(selectDataQuestions)
    const costQuestions = useSelector(selectCostQuestions)
    const expertiseQuestions = useSelector(selectExpertiseQuestions)

    const [name, setName] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')

    const handleNameChange = (event) => {
        setName(event.target.value);
      };
    const handleCompanyChange = (event) => {
        setCompanyName(event.target.value);
      };
    const handlePhoneChange = (event) => {
        setPhone(event.target.value);
      };
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
      };

      let emailBody=`He completado con Emerson la herramienta de optimización de plataformas de pozos en tierra y he descargado un PDF con mis resultados. Estoy interesado en saber más sobre cómo el caudalímetro multifásico (MPFM) Roxar 2600 puede mejorar mis operaciones. Me gustaría que un experto de Emerson se pusiera en contacto conmigo..\n\nInformación de contacto:\n${name}\n${companyName}\n${phone}\n${email}`

      emailBody = encodeURIComponent(emailBody)

    const calculateQuartile = (questions) => {
        const emptyQuestion = questions.find(question => question.answer === '')
        if (emptyQuestion){return 'incomplete'}
        var currentScore = 0
        var maxScore = 0
        for( var question of questions){
            currentScore += question.score
            maxScore += question.max
        }
        if(currentScore/maxScore > .75){
            return 'primer'
        } else if (currentScore/maxScore > .5){
            return 'segundo'
        } else if(currentScore/maxScore > .25) {
            return 'tercer'
        } else {
            return 'cuarto'
        }
    }
   

  const LEFT_MARGIN = 37;
  const INITIAL_Y = 85;
  const VERTICAL_SPACING = 30;
  const PDF_HEIGHT = 1123;
  const PDF_WIDTH = 794;
  const FONT_SIZE = 12;
  const TITLE_FONT_SIZE = 22;
  const FILL_COLOR = "#00358E";
  const LABEL_COLOR = "#1F598C";
  const VALUE_TEXT_COLOR = "#292929";

    const sections = [
        {
            title: 'Adaptabilidad y escalabilidad',
            icon: adaptabilityIcon,
            statements: {
                'primer': 'Su operación parece estar optimizada para responder a los cambios en la producción y escalar con sus objetivos operativos o las condiciones del mercado. Puede tener ventajas adicionales si se centra en cómo el Roxar 2600 puede ayudarle en otras áreas, como un mejor conocimiento de su producción, la disponibilidad de experiencia crítica o la optimización de costos. Consulte esas secciones para obtener más información.',
                'segundo': `Felicitaciones: lo está haciendo mejor que más de la mitad de sus colegas, pero parece que todavía hay margen de mejora para poder escalar su operación cuando llegue el momento, o para responder con rapidez a los cambios en el mercado o en las condiciones operativas que surjan. Esperamos poder seguir hablando con usted sobre cómo puede ayudar el caudalímetro multifásico Roxar 2600.`,
                'tercer': `Usted está en el camino hacia una operación ágil y escalable, pero puede haber más beneficios para usted en la implementación de una tecnología multifase que le ayude a escalar y adaptarse mejor. Nuestros expertos están dispuestos a discutir con usted las ideas que pueden ayudarle a responder mejor a los cambios en el rendimiento de la producción, los objetivos empresariales o la dirección del mercado.`,
                'cuarto': `Parece que el caudalímetro multifásico Roxar 2600 podría proporcionarle una ventaja significativa para ayudarle a responder a los cambios en el rendimiento de los pozos, así como a adaptarse rápidamente a los cambios en las condiciones del mercado o en la dirección del negocio. Esperamos poder compartir algunas de las mejores prácticas para optimizar su operación.`
            },
            quartile: calculateQuartile(adaptabilityQuestions),
            path: '/adaptability'
        },
        {
            title: 'Calidad de datos e información de producción',
            icon: dataIcon,
            statements: {
                'primer': `Es probable que sepa aprovechar al máximo lo que le dice el pozo, es decir, que identifique los problemas inminentes, que optimice el mantenimiento en curso y que se mantenga dentro del margen de funcionamiento de su equipo de pozo. Compruebe cómo el caudalímetro multifásico Roxar 2600 puede ayudarlo en otras áreas visitando las secciones de adaptabilidad y escalabilidad, disponibilidad de experiencia y ahorro de costos.`,
                'segundo': `Bien hecho: usted está en la mitad superior del grupo de colegas con respecto a la interpretación de lo que le dice el pozo. Pero puede haber más cosas que aprender para identificar problemas inminentes, optimizar el mantenimiento continuo y mantenerse dentro de la ventana de funcionamiento de su equipo de pozo. Esperamos poder seguir hablando con usted sobre cómo puede ayudar el caudalímetro multifásico Roxar 2600.`,
                'tercer': `Parece que actualmente tiene un buen control de lo que sale de la tierra, pero puede haber más beneficios en la identificación de problemas inminentes, la optimización del mantenimiento en curso y la permanencia dentro de la ventana de funcionamiento de su equipo de pozo. Nuestros expertos están dispuestos a discutir con usted las ideas que pueden ayudarle a ver más allá en el futuro con la visión que un caudalímetro multifásico Roxar 2600 puede proporcionar.`,
                'cuarto': `Parece que el caudalímetro multifásico Roxar 2600 podría proporcionarle información significativa que puede ayudarlo a ver más allá en el futuro, identificando problemas inminentes, optimizando el mantenimiento en curso y manteniéndose dentro de la ventana de funcionamiento de su equipo de pozo. Esperamos poder compartir algunas de las mejores prácticas para optimizar su operación.`
            },
            quartile: calculateQuartile(dataQuestions),
            path: '/data'
        },
        {
            title: 'Disponibilidad de conocimientos técnicos',
            icon: expertiseIcon,
            statements: {
                'primer': `Es probable que esté sacando el máximo partido a su personal y que haya encontrado la fina línea entre la experiencia, la disponibilidad, el costo y la seguridad en cuanto a su personal. Compruebe cómo el caudalímetro multifásico Roxar 2600 puede ayudarle en otras áreas visitando las secciones de adaptabilidad y escalabilidad, calidad de datos y conocimiento de la producción, y ahorro de costos.`,
                'segundo': `Bien hecho, usted está por encima de la media en cuanto a poner en práctica su experiencia. Pero puede haber un poco más de margen para garantizar la disponibilidad, optimizar los conocimientos técnicos y asegurar un funcionamiento seguro y confiable. Esperamos poder seguir hablando con usted sobre cómo puede ayudar el caudalímetro multifásico Roxar 2600.`,
                'tercer': `Parece que tiene un buen control sobre la optimización del uso de su personal y la visión que aportan a su operación, pero puede haber más beneficios en términos de disponibilidad, aumento de la experiencia del personal y aumento del rendimiento de la seguridad, todo ello mientras   Nuestros expertos están listos para analizar con usted cómo el caudalímetro multifásico Roxar 2600 puede ayudar a estas mejoras, así como a aumentar la productividad y reducir los costos.`,
                'cuarto': `El caudalímetro multifásico Roxar 2600 puede ofrecer importantes ventajas en términos de aumento de la productividad y reducción de los costos de personal, a la vez que mejora la disponibilidad de la experiencia, el intercambio de conocimientos y el rendimiento de la seguridad. Esperamos poder compartir algunas de las mejores prácticas para optimizar su operación.`
            },
            quartile: calculateQuartile(expertiseQuestions),
            path:'/expertise'
        },
        {
            title: 'Ahorros de costos',
            icon: costIcon,
            statements: {
                'primer': `Parece que ha encontrado la línea exacta entre el CAPEX y el OPEX, manteniendo los costos bajos al mismo tiempo que está preparado para lo inesperado, y realiza gastos de forma preventiva en el mantenimiento para evitar los costos más grandes de parada imprevista. Compruebe cómo el caudalímetro multifásico Roxar 2600 puede ayudarlo en otras áreas visitando las secciones de adaptabilidad y escalabilidad, calidad de datos y conocimiento de la producción, y disponibilidad de experiencia.`,
                'segundo': `Buen trabajo: lo está haciendo mejor que más de la mitad de sus colegas. Pero parece que todavía hay margen para mejorar los costos: optimizar el mantenimiento preventivo frente al correctivo, reducir la inversión en CAPEX y evitar la costosa (y a menudo iterativa) resolución de problemas. Esperamos poder seguir hablando con usted sobre cómo puede ayudar el caudalímetro multifásico Roxar 2600.`,
                'tercer': `Ha iniciado el camino para destinar los costos a donde deben ir, pero parece que aún podría beneficiarse de la optimización del mantenimiento preventivo frente al correctivo, la reducción de la inversión en CAPEX y la eliminación de la costosa (y a menudo iterativa) resolución de problemas. Nuestros expertos están preparados para analizar con usted ideas que le ayuden a mantener los costos tan bajos como sea posible, sin dejar de estar preparado para lo inesperado.`,
                'cuarto': `Parece que el caudalímetro multifásico Roxar 2600 podría proporcionarle un importante ahorro de costos, al reducir los gastos de CAPEX, mantener bajos los costos operativos y evitar eventos no planificados que pueden hacer que su presupuesto se salga de control. Esperamos compartir con usted algunas de las mejores prácticas para optimizar su gasto y reducirlo.`
            },
            quartile: calculateQuartile(costQuestions),
            path: '/cost'
        },
    ]


  let doc = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: [PDF_WIDTH, PDF_HEIGHT],
  });

  const initiatePDF = () => {
    doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [PDF_WIDTH, PDF_HEIGHT],
    });

    //set font
    doc.setFontSize(FONT_SIZE);
    doc.setFont("helvetica");
    doc.setTextColor("#26588C");
  };

  const handlePDFCreation = () => {
    //start it up
    initiatePDF();

    let currentY = 0;

    doc.setFillColor(FILL_COLOR);
    doc.rect(0, currentY, PDF_WIDTH, 53, "FD");
    //make header image
    doc.addImage("images/emerson-pdf-logo.png", "PNG", PDF_WIDTH - 121, 10, 82, 35);
    //Title
    doc.setTextColor("#FFFFFF");
    doc.setFont("helvetica", "normal");
    doc.setFontSize("22");
    doc.text("Herramienta de optimización de plataformas de pozos en tierra", LEFT_MARGIN, 36);

    currentY = INITIAL_Y + 5;
    doc.setTextColor("#000000");
    doc.text("Resultados de oportunidades de optimización", LEFT_MARGIN, currentY);
    currentY += 20;
    doc.setFontSize("16");
    doc.text("Los resultados que aparecen a continuación se basan en sus respuestas en las secciones completadas.", LEFT_MARGIN, currentY);
    currentY += 30;

    const charts = {
      "primer": chart1,
      "segundo": chart2,
      "tercer": chart3,
      "cuarto": chart4,
    };

    let currentX = LEFT_MARGIN;
    //Top Left Graph
    sections.map((section, index) => {
      let sectionY = currentY;
      let titleMargin = 60;

      if (section.quartile !== "incomplete") {
        doc.addImage(section.icon, "JPEG", currentX, sectionY, 50, 50);
        sectionY += 11;
        doc.setFontSize("22");
        doc.text(section.title, currentX + titleMargin, sectionY);
        doc.setFontSize("13");
        sectionY += 15;
        doc.text(`Usted se clasifica en el ${section.quartile} caurtil:`, currentX + titleMargin, sectionY);
        sectionY += 30;
        doc.addImage(charts[section.quartile], "JPEG", currentX, sectionY, 300, 100);
        sectionY += 110;
        //text box
        doc.setFillColor("#F0F0F0");
        doc.rect(currentX, sectionY, 300, 150, "F");
        let quartileString = section.statements[section.quartile];
        doc.setFontSize("16");
        doc.text(quartileString, currentX + 10, sectionY + 30, { maxWidth: 280, align: "left" });

        if (currentX == LEFT_MARGIN) {
          currentX += 400;
        } else {
          currentX = LEFT_MARGIN;
          currentY += 380;
        }
      } else {
        // doc.addImage(section.icon, "JPEG", currentX, sectionY, 50, 50);
        // sectionY += 11;
        // doc.setFontSize('22');
        // doc.text(section.title, currentX + titleMargin, sectionY);
        // doc.setFontSize('13');
        // sectionY += 15;
        // doc.text(`You rank in the ${section.quartile} quartile:`, currentX + titleMargin, sectionY);
        // sectionY += 30;
        // doc.addImage(chart4, "JPEG", currentX, sectionY, 300, 100);
        // sectionY += 110;
        // //text box
        // doc.setFillColor('#F0F0F0');
        // doc.rect(currentX, sectionY, 300, 150, 'F');
        // let quartileString = section.statements['4th'];
        // doc.setFontSize('16');
        // doc.text(quartileString, currentX + 10, sectionY + 30, {maxWidth: 280, align: 'left'});
      }

      // if (currentX == LEFT_MARGIN) {
      //     currentX += 400;
      // } else {
      //     currentX = LEFT_MARGIN;
      //     currentY += 380;
      // }
    });

    //save it!
    doc.save("emerson-form.pdf");
  };

  return (
    <Container maxWidth='lg' className='results_content'>
      <div>
        <Grid container justifyContent='center' rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid className='results_heading' item xs={12} sm={8}>
            <h1>Resultados de oportunidades de optimización</h1>
            <p>Los resultados que aparecen a continuación se basan en sus respuestas en las secciones completadas. Para guardar sus resultados o ponerse en contacto con un representante de Emerson, haga clic en “enviar resultados” o desplácese hasta el final de la página.</p>
          </Grid>
          <Grid item xs={12} sm={4} justifyContent='flex-end'>
            <Button component={"a"} href='#contact' className='next_button result_button'>
             <span>Enviar resultados</span><ArrowForwardIos />
            </Button>
          </Grid>
        </Grid>
      </div>

      <div className='results_container'>
        <Grid container justifyContent='center' rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {sections.map((section, index) =>
            section.quartile === "incomplete" ? (
              <Grid className='singleResultWrapper' item xs={12} sm={6}>
                <Oops className='singleResultWrapper' key={index} section={section} />
              </Grid>
            ) : (
              <Grid className='singleResultWrapper' item xs={12} sm={6}>
                <Result key={index} section={section} />
              </Grid>
            )
          )}
        </Grid>
      </div>

      <div id='contact' className='contact_container'>
        <div className='save_results'>
          <h2>Genere un PDF y descargue sus resultados.</h2>
          <div className='contact_info'>
           


            <Grid item xs={0} sm={8} md={9}></Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Button className='next_button save_button' onClick={handlePDFCreation}>
                <span>Descargar resultados</span>
                <ArrowForwardIos />
              </Button>
            </Grid>
          </div>
        </div>


        <div className='talk_to_Roxar'>
          <Grid item xs={12}>
            <h2>Hable con un experto de Roxar</h2>
            <p>¿Está interesado en saber más sobre cómo el caudalímetro multifásico (MPFM) Roxar 2600 podría mejorar sus operaciones? Póngase en contacto con un experto del equipo de Emerson hoy mismo para programar una conversación.</p>
          </Grid>


          <div className='contact_info'>
            <Grid container justifyContent='center' rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Nombre' onChange={ e => handleNameChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label=' Nombre de la Empresa' onChange={ e => handleCompanyChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Teléfono' onChange={ e => handlePhoneChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Correo Electrónico' onChange={ e => handleEmailChange(e) } />
              </Grid>

              <Grid item xs={0} sm={8} md={9}></Grid>
              <Grid item xs={12} sm={4} md={3}>
                 <Button component='a' href={`mailto:info@roxar.com?subject=${name} con ${companyName} quiere obtener más información sobre la optimización de las plataformas de pozos con ROXAR &body=${emailBody}`} className='next_button save_button'><span>Experto en correo electrónico</span><ArrowForwardIos /></Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Container>
  );
            }


export default Results;
